import React, { useState, useEffect } from 'react';

//Components
import FichaCertificado from './FichaCertificado';
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';

//Api
import certificado_api from '../../../api/certificado_api';

//hHelpers
import { showMessage } from '../../../helpers/message';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

export default function Certificados({ permissao }) {

    //Guarda lista de tipos de certificados
    const [certificados, setCertificados] = useState([]);

    //Guarda o id da do tipo de certificado escolhido
    const [tipoCertificado, setTipoCertificado] = useState(false);

    //Guarda o estado do loading na tela
    const [loading, setLoading] = useState(false);

    //Cabeçalhos da lista de certificados
    const headers = [
        { value: "Tipos", objectValue: "tipoDocumento", align: "left" }
    ]

    //Função do botão visualizar da lista
    const visualizar = (item) => { setTipoCertificado(item.id) };

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.visualizar(visualizar)];

    //Função do botão voltar da tela de fichaCertificados
    const btnVoltar = () => setTipoCertificado(false);

    //Carrega os tipos de certificados
    useEffect(() => {
        setLoading(true);
        certificado_api.GetListTipoDocumento().then(response => {
            response.data = response.data.map(v => { return { id: v, tipoDocumento: v } })
            setCertificados(response.data)
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        });
    }, []);

    //Carrega os certificados para determinado tipo de ceriticado
    if (tipoCertificado) {
        return <FichaCertificado tipoDocumento={tipoCertificado} loading={loading} setLoading={setLoading} btnVoltar={btnVoltar} permissao={permissao} />
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard>
                <div className="mt-4">
                    <TabelaListagem actions={actions} title={"Lista de tipos de certificados"} headers={headers} items={certificados} />
                </div>
            </MainCard>
        </>
    )
}